import React from 'react';
import PropTypes from 'prop-types';
import { converter } from '../../../../helpers/converter';

export default function DownloadButton({
  visible,
  onDownload,
  asset,
  translations,
  callMetrics,
  contentData,
}) {
  if (!visible) {
    return null;
  }

  const handleClick = () => {
    const eventAction = 'Descarga';
    callMetrics(eventAction);
    onDownload({
      episodeId: contentData.id,
      title: contentData.title,
      isSerie: contentData.isSerie,
    });
  };

  return (
    <button className="btn btn-default btn-lg primary" onClick={handleClick}>
      <span className="text-inline">
        {converter.convertApaUnicode(
          translations,
          'download_button',
          'Descargar',
        )}
      </span>
      <img src={asset.dw_assets_to_download} alt="" className="icon-inline" />
    </button>
  );
}

DownloadButton.propTypes = {
  visible: PropTypes.bool,
  onDownload: PropTypes.func.isRequired,
  callMetrics: PropTypes.func,
  translations: PropTypes.shape(),
  asset: PropTypes.shape(),
  contentData: PropTypes.shape({
    title: PropTypes.string,
    id: PropTypes.string,
  }),
};
